export const fleetsViewPaths = {
  absolute: '/:clientId/fleets-view',

  alertDetails: {
    absolute: '/:clientId/fleets-view/alert/:alertId',
    relative: 'alert/:alertId',
  },

  attackDetails: {
    absolute: '/:clientId/fleets-view/attack/:attackId',
    relative: 'attack/:attackId',
  },

  aiAnomaliesDetails: {
    absolute: '/:clientId/fleets-view/ai-anomalies/:anomalyId',
    relative: 'ai-anomalies/:anomalyId',
  },
} as const;
